var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    enableBackground: "new 0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 48.8,
    cy: 15.2,
    r: 3.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,16.1c-8.8,0-15.9,7.1-15.9,15.9S23.2,47.9,32,47.9S47.9,40.8,47.9,32S40.8,16.1,32,16.1z M32,42.9 c-6,0-10.9-4.9-10.9-10.9S26,21.1,32,21.1S42.9,26,42.9,32S38,42.9,32,42.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8,19.7c-0.1-3.1-0.6-5.6-1.5-8c-0.9-2.4-2.2-4.3-4-6.1c-1.8-1.8-3.7-3-6.1-4c-2.4-0.9-4.8-1.4-8-1.5C41.1,0,40,0,32,0 s-9.1,0-12.3,0.2c-3.1,0.1-5.6,0.6-8,1.5c-2.4,0.9-4.3,2.2-6.1,4c-1.8,1.8-3,3.7-4,6.1c-0.9,2.4-1.4,4.8-1.5,8C0,22.9,0,24,0,32 s0,9.1,0.2,12.3c0.1,3.1,0.6,5.6,1.5,8c0.9,2.4,2.2,4.3,4,6.1c1.8,1.8,3.7,3,6.1,4c2.4,0.9,4.8,1.4,8,1.5C22.9,64,24,64,32,64 s9.1,0,12.3-0.2c3.1-0.1,5.6-0.6,8-1.5c2.4-0.9,4.3-2.2,6.1-4c1.8-1.8,3-3.7,4-6.1c0.9-2.4,1.4-4.8,1.5-8C64,41.1,64,40,64,32 S64,22.9,63.8,19.7z M58.8,44c-0.1,2.6-0.5,4.5-1.2,6.4c-0.7,1.7-1.5,3.1-2.8,4.4s-2.6,2.2-4.4,2.8c-1.8,0.7-3.8,1.1-6.4,1.2 C41,59,39.9,59,32,59s-9,0-12-0.2c-2.6-0.1-4.5-0.5-6.4-1.2c-1.7-0.7-3.1-1.5-4.4-2.8s-2.2-2.6-2.8-4.4c-0.7-1.8-1.1-3.8-1.2-6.4 C5,40.9,5,39.9,5,32s0-8.9,0.2-12c0.1-2.6,0.5-4.5,1.2-6.4c0.7-1.7,1.5-3.1,2.8-4.4s2.6-2.2,4.4-2.8c1.8-0.7,3.8-1.1,6.4-1.2 C23,5,24.1,5,32,5s9,0,12,0.2c2.6,0.1,4.5,0.5,6.4,1.2c1.7,0.7,3.1,1.5,4.4,2.8s2.2,2.6,2.8,4.4c0.7,1.8,1.1,3.8,1.2,6.4 C59,23,59,24.1,59,32S59,41,58.8,44z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.b38e6850f9f1ebe111b3f021335d48e7.svg";
export { ForwardRef as ReactComponent };